<template>
	<div class="c-modal-folder-delete-confirmation">
		<Modal v-model="options.active" @input="closeModal" :closable="true">
			<template v-slot:title>
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M2 10.5H22M22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H7.79844C8.25258 4 8.6932 4.15456 9.04783 4.43826L10.4522 5.56174C10.8068 5.84544 11.2474 6 11.7016 6H19C20.6569 6 22 7.34315 22 9Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-width="1.5"
					/>
				</svg>

				<h3>Delete this folder?</h3>
			</template>
			<template>
				<p>
					Once this folder is deleted, all boards inside the folder will be
					moved to the Default folder.
				</p>
				<button
					:disabled="processing === true"
					class="btn btn-primary"
					@click="onDeleteFolder"
				>
					Yes, delete folder
				</button>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from './index.vue';
import { parseISO, format } from 'date-fns';
import FormFolderUpdate from '../form/form-folder-update';

export default {
	components: {
		Modal,
		FormFolderUpdate,
	},

	data: function () {
		return {
			options: {
				name: 'modal-folder-delete-confirmation',
				active: false,
			},
			forceRender: true,

			processing: false,
		};
	},

	props: {
		selection: {},
	},

	watch: {
		'options.active': {
			handler: function () {},
		},
		deleteConfirmationId: function () {
			if (this.deleteConfirmationId) {
				this.options.active = true;
			} else {
				this.options.active = false;
			}
		},
		folder: function () {
			this.forceRender = false;
			this.$nextTick(() => {
				this.forceRender = true;
			});
		},
	},

	computed: {
		deleteConfirmationId: function () {
			return this.$store.getters['folders/deleteConfirmationId'];
		},
		folder: function () {
			if (!this.deleteConfirmationId) {
				return;
			}
			let folders = this.$store.getters['folders/filtered'];

			let folder = null;

			for (let i = 0; i < folders.length; i++) {
				const f = folders[i];
				if (f.id === this.deleteConfirmationId) {
					folder = f;
					break;
				}
			}

			return folder;
		},
	},

	methods: {
		onSubmit: function () {},
		activate: function () {
			this.options.active = true;
		},
		closeModal: function () {
			this.$store.dispatch('folders/setDeleteConfirmationId', null);
			//this.options.active = false;
		},
		afterDelete: function () {
			this.closeModal();
		},
		async onDeleteFolder() {
			const folder = this.folder;
			this.closeModal();
			this.processing = true;

			await this.$store.dispatch('message/sendMessage', {
				message: 'Deleting folder',
				timer: 1500,
			});

			const condition = await this.$store.dispatch('folders/remove', folder.id);

			if (condition) {
				await this.$store.dispatch('message/sendMessage', {
					message: 'Folder deleted',
					timer: 2000,
					status: 'success',
				});
			} else {
				await this.$store.dispatch('message/sendMessage', {
					message: `Couldn't delete folder, please try again`,
					timer: 2000,
				});
			}

			this.processing = false;
		},
	},

	mounted: function () {},
};
</script>

<style lang="scss">
.c-modal-folder-delete-confirmation {
	.vfm__overlay {
		&.non-closable {
		}
	}
	.modal-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		overflow-y: auto;
		padding: 0;
	}

	.modal-content {
	}

	.form-edit-boards {
		align-self: baseline;
	}

	.modal-content {
		overflow: hidden;
	}

	.modal {
		&__title {
			display: flex;
			align-items: center;
			padding: 16px var(--spacer);
			background-color: var(--color-bg-2);
			border-bottom: var(--color-bg-4) solid 1px;

			svg {
				width: 32px;
				height: 32px;
				margin-right: var(--margin-lg);
			}

			h3 {
				margin-bottom: 0;
			}
		}

		&__content {
			padding-top: var(--spacer-sm);
			padding-bottom: var(--spacer-sm);
			background-color: var(--color-bg-1);
		}

		&__footer {
			padding: 16px var(--spacer);
			background-color: var(--color-bg-2);
			border-top: var(--color-bg-4) solid 1px;
		}
	}
}
</style>
